export default __webpack_public_path__ + "static/media/bottle_main.0d88a28e.png";